<template>
  <div>
    <Ibox :back="true" :titulo="'Actividades'">
      <b-col cols="12">
        <DataTable
          :loading="loading_tabla"
          :columns="columns"
          :rows="rows">
          <div slot="table-actions">
            <router-link 
              class="btn btn-primary btn-sm" 
              v-if="utils.tienePermiso()"
              tag="button" 
              :to="{ name: 'programa/actividad/agregar', params: {programa: utils.je64(this.programa)} }">Agregar actividad
            </router-link>
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'action' && utils.tienePermiso()">
              <router-link :to="{ name: 'programa/actividad/editar', params: { actividad: utils.je64(agregarPrograma(props.row)) } }">Editar</router-link>
              |
              <a href="javascript:void(0)" v-on:click="eliminar( props.row )">Eliminar</a>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </DataTable>
      </b-col>
    </Ibox>
  </div>
</template>

<script>
import { programaService } from '@/services';
import { utils } from '@/helpers';

export default {
  name: 'Programas', 
  data(){
    return {
      utils,
      programa: utils.jd64(this.$route.params.programa),
      loading_tabla: true,
      columns:[
        {label: 'Descripcion', field: 'descripcion'},
        {label: '', field: 'action'}
        ],
      rows:[],
    }
  },
  mounted () {
    this.cargarDatos();
    this.$store.commit("pagina/setTitulo",'Configuración / Programa '  + this.programa.nombre_programa + ' / Actividades' );
  },
  methods : {
    cargarDatos(){
      this.loading_tabla = true;

      programaService.getProgramaActividades(this.programa).then(data => {
        this.rows = data.data;

        this.loading_tabla = false;
      });
    },
    eliminar(row){
      this.$fire({
        showCancelButton: true,
        html:'Esta accion eliminara permanentemente la actividad, ¿esta seguro que desea continuar?',
        confirmButtonText:
          'Si',
        cancelButtonText:
          'No',
      }).then((confirm) => {
        if(confirm.value != null){
          programaService.deleteProgramaActividad(row).then(respuesta => {
            utils.alerta(respuesta);
            this.cargarDatos();
          });
        }
      });
    },
    agregarPrograma(row){
      row.nombre_programa = this.programa.nombre_programa;
      return row;
    }
  }
}
</script>

<style scoped>

</style>
